// extracted by css-extract-rspack-plugin
export default {"listFooter":"JrWDCTtYHKga5Ss7","popover":"rC6EhOgfK6octS7U"};